import { useContext, useEffect, useRef } from 'react';
import LayersContext from '../components/Helper/Layer/LayersContext';
export function useIsolate() {
  const context = useContext(LayersContext);
  const previousValue = useRef();
  const root = context?.root;
  const hide = () => {
    if (root instanceof HTMLElement) {
      previousValue.current = root.getAttribute('aria-hidden') || '';
      root.setAttribute('aria-hidden', 'true');
    }
  };
  const undo = () => {
    if (root instanceof HTMLElement) {
      root.setAttribute('aria-hidden', previousValue.current);
    }
  };
  useEffect(() => {
    hide();
    return () => {
      undo();
    };
  }, []);
  return () => {
    undo();
  };
}